import { Stack, styled } from "@mui/material";

import CustomSearchInput from "@/components/custom/custom-search-input";
import CustomSelectInput from "@/components/custom/custom-select-input";
import { useSearchParams } from "react-router-dom";
import { usePayouts } from "@/hooks/use-payouts";
import { DataTable } from "@/components/custom/data-table";
import CustomPagination from "@/components/custom/custom-pagination";
import { useMemo } from "react";
import { PayoutColumns } from "@/components/transactions/payout-columns";

const SectionRoot = styled("section")(({ theme }) => ({
  margin: theme.spacing(2),
}));

const Card = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: "16px 20px",
  borderRadius: "8px",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

export const Payouts = () => {
  const [searchParams] = useSearchParams();
  const searchValue = searchParams.get("search") || "";

  const currentPage = Number(searchParams.get("page") || 0);
  const pageSize = Number(searchParams.get("size") || 20);
  const status = searchParams.get("status");

  const queryParams = {
    page: currentPage,
    size: pageSize,
    status: status ? status : undefined,
    search: searchValue,
  };

  const {
    data: payouts,
    isLoading: isPayoutsLoading,
    isError,
  } = usePayouts(true, queryParams);

  const columns = useMemo(() => PayoutColumns, []);

  return (
    <SectionRoot>
      <Card>
        <Stack direction="row" spacing={3} flexWrap="wrap">
          <CustomSearchInput paramKey="search" placeholder="Search payouts..." />
          <CustomSelectInput
            paramKey="status"
            label="Status"
            placeholder="All Status"
            options={[
              { label: "Pending", value: "PENDING" },
              { label: "Success", value: "SUCCESS" },
              { label: "Failed", value: "FAILED" },
              { label: "Reversed", value: "REVERSED" },
            ]}
          />
        </Stack>

        <DataTable
          data={payouts?.data ?? []}
          columns={columns}
          isLoading={isPayoutsLoading}
          isError={isError}
          noDataMessage="No payouts found."
        />

        <CustomPagination
          total={payouts?.total_count ?? 0}
          perPageOptions={[10, 20, 50, 100]}
        />
      </Card>
    </SectionRoot>
  );
};
